import { useState } from 'react';
import { css } from '@emotion/react';
import { FloatingBox } from '../../display/FloatingBox';
import { IconButton } from '../../navigation/IconButton';
import { Menu, MenuItem } from '../../forms/Menu';
import { useClickOutside } from '../../../hooks';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const Styles = labelStyles('TabsDropdown', {
    root: css `
    position: relative;
  `,
    summary: css `
    // Hides default icon on details element
    &::-webkit-details-marker {
      display: none;
    }

    &::before {
      display: none;
    }
  `,
    menu: css `
    padding: 10px;
    min-width: 250px;
  `,
});
export const TabsDropdown = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuItems = props.items.map((item) => (isolateComponent(MenuItem, { disabled: item.disabled, href: item.href, isSelected: item.href === props.selectedItemHref, key: item.href, onClick: (event) => {
            setIsOpen(false);
            props.onChooseItem(item, event);
        } }, item.text)));
    const [setClickOutsideNode] = useClickOutside({
        onClickOutside: () => {
            setIsOpen(false);
        },
    });
    const containerHandlers = {
        onKeyUp: (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
            }
        },
    };
    return (isolateComponent("div", Object.assign({ ref: setClickOutsideNode }, containerHandlers),
        isolateComponent(IconButton, { color: "icon-primary", icon: "navMoreHoriz", label: "More items\u2026", ariaExpanded: isOpen, onClick: () => setIsOpen(!isOpen), size: {
                medium: 'xsmall',
                large: 'small',
            }[props.size], tooltipPosition: "west" }),
        isOpen && (isolateComponent(FloatingBox, { align: "right" },
            isolateComponent("div", { css: Styles.menu },
                isolateComponent(Menu, { ariaLabel: "" }, menuItems))))));
};
//# sourceMappingURL=TabsDropdown.js.map
// @zapier/design-system@6.14.1 (10126c41d)
